'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderSection = exports.HEADER_SCROLL_UP_TRIGGER = exports.HEADER_SWAP_TRIGGER = exports.CLASS_HEADER_VISIBLE = exports.CLASS_TEXT_WHITE = exports.CLASS_UP = exports.CLASS_FIXED = exports.BORDER_ELEMENT = exports.CART_COUNTER = exports.SEARCH_TOGGLE = exports.SEARCH_BAR_SHOW = exports.TOP_BAR_SELECTOR = exports.HEADER_INNER = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShopifySection2 = require('./../ShopifySection');

var _DesktopMenu = require('./../../components/menu/DesktopMenu');

var _MobileMenu = require('../../components/menu/MobileMenu');

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _SearchBar = require('./../../components/search/SearchBar');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Elements
/*
 *  Header Section
 *    Provides scripts for elements within the header section.
 *
 *  Version:
 *    1.0.0 - 2020/05/16
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-header-container]';
var HEADER_INNER = exports.HEADER_INNER = '[data-header-inner]';
var TOP_BAR_SELECTOR = exports.TOP_BAR_SELECTOR = '[data-topbar]';
var SEARCH_BAR_SHOW = exports.SEARCH_BAR_SHOW = '[data-search-show]';
var SEARCH_TOGGLE = exports.SEARCH_TOGGLE = '[data-header-search-toggle]';
// export const SEARCH_INPUT = '[data-search-input-desktop]';
var CART_COUNTER = exports.CART_COUNTER = '[data-cart-counter]';
var BORDER_ELEMENT = exports.BORDER_ELEMENT = '[data-header-border]';

//Classes
var CLASS_FIXED = exports.CLASS_FIXED = 'is-fixed';
var CLASS_UP = exports.CLASS_UP = 'is-scroll-up';
var CLASS_TEXT_WHITE = exports.CLASS_TEXT_WHITE = 'has-header-text-colour-white';
var CLASS_HEADER_VISIBLE = exports.CLASS_HEADER_VISIBLE = 'is-visible';

//Trigger Variables
var HEADER_SWAP_TRIGGER = exports.HEADER_SWAP_TRIGGER = 400;
var HEADER_SCROLL_UP_TRIGGER = exports.HEADER_SCROLL_UP_TRIGGER = 200;

var HeaderSection = exports.HeaderSection = function (_ShopifySection) {
  (0, _inherits3.default)(HeaderSection, _ShopifySection);

  function HeaderSection(container) {
    (0, _classCallCheck3.default)(this, HeaderSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HeaderSection.__proto__ || Object.getPrototypeOf(HeaderSection)).call(this, container));

    _this.desktopMenu = new _DesktopMenu.DesktopMenu(_this, container.find(_DesktopMenu.DESKTOP_MENU_SELECTOR));
    _this.mobileMenu = new _MobileMenu.MobileMenu(container, container.find(_MobileMenu.MOBILE_MENU_SELECTOR));

    _this.inner = container.find(HEADER_INNER);
    _this.topBar = container.find(TOP_BAR_SELECTOR);

    _this.cartCount = container.find(CART_COUNTER);
    _this.mobileMenuElement = container.find(_MobileMenu.MOBILE_MENU_SELECTOR);

    _this.searchBar = container.find(_SearchBar.SEARCH_BAR_CONTAINER);
    _this.searchBarShow = container.find(SEARCH_BAR_SHOW);
    _this.search = new _SearchBar.SearchBar(_this.searchBar);

    container.on('click touchend', SEARCH_BAR_SHOW, function (e) {
      return _this.search.onSearchShow(e);
    });

    _this.checkPosition();
    _this.calculateHeaderHeight();

    $(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
      return _this.onCartFinished();
    });

    $(window).on('resize orientationchange', function () {
      return _this.calculateHeaderHeight();
    });
    var headerIsTransparent = container.attr('data-is-transparent');
    if (headerIsTransparent) {
      document.body.classList.add('has-transparent-header');
    }
    _this.handleRainbowBarScroll();
    return _this;
  }

  (0, _createClass3.default)(HeaderSection, [{
    key: 'onSearchClick',
    value: function onSearchClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.searchBar.addClass(CLASS_VISIBLE);
    }
  }, {
    key: 'calculateHeaderHeight',
    value: function calculateHeaderHeight() {
      this.topbarHeight = this.topBar.outerHeight();
    }
  }, {
    key: 'checkPosition',
    value: function checkPosition() {
      var _this2 = this;

      var top = $(window).scrollTop();

      //Fix our Header element
      if (top > this.topbarHeight) {
        this.inner.addClass(CLASS_FIXED);
        this.mobileMenuElement.addClass(CLASS_FIXED);
      } else {
        this.inner.removeClass(CLASS_FIXED);
        this.mobileMenuElement.removeClass(CLASS_FIXED);

        var offset = this.topbarHeight - top + 60;
        if (offset != this.offset) {
          // this.mobileMenuElement.css('top', `${offset}px`);
          this.offset = offset;
        }
      }

      //Visible state of the header
      if (top > this.topbarHeight + this.inner.outerHeight()) {
        this.inner.removeClass(CLASS_HEADER_VISIBLE);
      } else {
        this.inner.addClass(CLASS_HEADER_VISIBLE);
      }
      //Are we scrolling down or up?
      if (top < this.top && top > HEADER_SWAP_TRIGGER) {
        this.inner.addClass(CLASS_UP);
        this.scrollDown = true;
      } else if (top > this.top || top == 0) {
        this.inner.removeClass(CLASS_UP);
        this.scrollUp = false;
      }

      //Reset the variable
      this.top = top;

      requestAnimationFrame(function () {
        return _this2.checkPosition();
      });
    }
  }, {
    key: 'onCartFinished',
    value: function onCartFinished() {
      var _getCurrentCart = (0, _pcSlateTools.getCurrentCart)(),
          item_count = _getCurrentCart.item_count;

      if (item_count > 0) {
        this.cartCount.html(item_count);
      } else {
        this.cartCount.html('');
      }
    }
  }, {
    key: 'onClickOutsideSearch',
    value: function onClickOutsideSearch(e) {
      var _this3 = this;

      var check = $(SEARCH_BAR).find(e.target);
      if (check.length) return;
      this.searchElements.forEach(function (e) {
        return $(e).removeClass(CLASS_OPEN);
      });
      $(document).off('click', function (e) {
        return _this3.onClickOutsideSearch(e);
      });
    }
  }, {
    key: 'onSearchToggle',
    value: function onSearchToggle(e) {
      var _this4 = this;

      e.preventDefault();
      e.stopPropagation();

      //Hide Help Modal, if visible
      if (this.helpModal.hasClass(CLASS_OPEN)) {
        this.helpElements.forEach(function (e) {
          return $(e).removeClass(CLASS_OPEN);
        });
      }

      this.searchElements.forEach(function (e) {
        return $(e).toggleClass(CLASS_OPEN);
      });
      if (this.searchBar.hasClass(CLASS_OPEN)) {
        setTimeout(function () {
          return _this4.searchInput.focus();
        }, 250);
        $(document).on('click', function (e) {
          return _this4.onClickOutsideSearch(e);
        });
      } else {
        $(document).off('click', function (e) {
          return _this4.onClickOutsideSearch(e);
        });
      }
    }
  }, {
    key: 'handleRainbowBarScroll',
    value: function handleRainbowBarScroll() {
      var _this5 = this;

      this.headerBorder = this.container.find(BORDER_ELEMENT);

      $(window).on('scroll', function () {
        var top = $(window).scrollTop();
        // let height
        _this5.headerBorder.css('background-position', parseInt(top / 5) + '% 0%');
      });
    }
  }]);
  return HeaderSection;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, HeaderSection);